import React, { useState } from 'react';
import { Mail, X, AlertCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import authService from '../../services/authService';

function EmailVerificationBanner({ email, onClose }) {
  const [isResending, setIsResending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleResend = async () => {
    try {
      setIsResending(true);
      await authService.resendVerificationEmail(email);
      toast.success('Verification email sent! Please check your inbox.');
    } catch (error) {
      toast.error(error.message || 'Failed to resend verification email');
    } finally {
      setIsResending(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    if (onClose) onClose();
  };

  if (dismissed) return null;

  return (
    <div className="bg-yellow-500/[0.05] border border-yellow-500/20 rounded-[16px] p-4 sm:p-5 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="p-2 rounded-[10px] bg-yellow-500/10">
            <AlertCircle className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
          </div>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-sm font-semibold text-yellow-800 dark:text-yellow-200 mb-1">
            Verify Your Email Address
          </h3>
          <p className="text-sm text-yellow-700 dark:text-yellow-300 mb-3">
            We sent a verification link to <strong>{email}</strong>. Please check your inbox and click the link to verify your account.
          </p>
          <div className="flex items-center space-x-3">
            <button
              onClick={handleResend}
              disabled={isResending}
              className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-yellow-600 hover:bg-yellow-700 disabled:bg-yellow-400 text-white text-sm font-medium transition-colors"
            >
              {isResending ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  <span>Sending...</span>
                </>
              ) : (
                <>
                  <Mail className="w-4 h-4" />
                  <span>Resend Verification Email</span>
                </>
              )}
            </button>
            <button
              onClick={handleDismiss}
              className="text-sm text-yellow-700 dark:text-yellow-300 hover:text-yellow-900 dark:hover:text-yellow-100 underline"
            >
              Dismiss
            </button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="ml-4 flex-shrink-0 text-yellow-600 dark:text-yellow-400 hover:text-yellow-800 dark:hover:text-yellow-200"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}

export default EmailVerificationBanner;
